<template>
    <div>
      <div class="calendar-button" v-if="!calendarCard">
        <button @click="show_calendar()" class="btn-calendar">
          {{$t('calendar_text')}}
        </button>
      </div>
  
      <v-dialog v-model="calendarCard" width="80%">

        <new-calendar 
            :input_station_id="input_station_id"
            :need_show_calendar="need_show_calendar"
        />
        
        <div class="calendar-button" style="width: auto;">
          <button @click="calendarCard = false" class="btn-calendar close-btn-calendar">{{$t('close_calendar_text')}}</button>
        </div>
  
      </v-dialog>
    </div>
  </template>
  
  
  <script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import newCalendar from './CalendarNew.vue';

    export default {
      props: {
        input_station_id: Number,
      },

      data: () => ({
        calendarCard: false,
        need_show_calendar: null,
      }),

      components:{
        newCalendar
      },

      methods:{  
        show_calendar(){
            this.need_show_calendar = new Date()
            this.calendarCard = true
        },
      },
    }
  </script>
  
  
  <style scoped>
    .btn-calendar{
      background: #15236d;
      border-radius: 10px 10px 0 0;
      color:white;
      width:120px;
      height: 52px;
      line-height:10px;
      padding: 15px 15px;
    }
    .close-btn-calendar{
      background: #d63535;
    }
    .btn-calendar:hover{
      cursor: pointer;
      background: green;
      font-weight:bold;
  
    }
    .calendar-button {
      display: flex;
      justify-content: center;
      position: fixed;
      top: 352px;
      /* top: calc(20% - 57px); */
      left: calc(100% - 85px);
      transform: rotate(-90deg);
    }
  </style>